import { render } from "./ConfirmEmailForm.vue?vue&type=template&id=6574fbf0"
import script from "./ConfirmEmailForm.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__